import fnv1a from '@sindresorhus/fnv1a'

const generateId = (
  submissionId: string,
  parentId: string | null,
  childIndex: number
): string => {
  const fingerprint = `${submissionId}|${parentId}|${childIndex}`
  const hash = fnv1a(fingerprint, { size: 64 })
  return hash.toString(36)
}

export default generateId
